import { useTranslation } from "react-i18next";
import { Button } from "@/atoms/button";

/**
 * The two ways to get Gymkee, as text.
 *
 * Two tertiary buttons carrying the stores' names in our own face, side by side. Tertiary and
 * not secondary: two secondaries beside each other are forbidden (button-secondary 1.3 doNot 4),
 * and neither store is the more important of the two. Never the
 * official store badges: they are the stores' own assets at their own minimum sizes, they come
 * in their own colours, and a page whose one orange is the primary action cannot carry two more
 * brand blocks under it (receipt 1.1, DS28 "The stores are text").
 */

const APP_STORE =
  "https://apps.apple.com/app/id1489171293";
const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.gymkee";

export function StoreButtons() {
  const { t } = useTranslation();
  return (
    <div className="gap-gk-3 grid grid-cols-2">
      <Button
        variant="tertiary"
        href={APP_STORE}
        target="_blank"
        className="ds-pay-hand"
      >
        {t("gymkeePay.common.appStore")}
      </Button>
      <Button
        variant="tertiary"
        href={GOOGLE_PLAY}
        target="_blank"
        className="ds-pay-hand"
      >
        {t("gymkeePay.common.googlePlay")}
      </Button>
    </div>
  );
}
